import { Link } from "react-router-dom";
import { CONTACT_MAIL, mailto } from "../../lib/site";
import { Logo } from "./Nav";

const LINKS = [["/#solutions", "Solutions", "footer-solutions"], ["/strategie-ia/", "Stratégie IA", "footer-strategy"], ["/a-propos/", "À propos", "footer-about"],
  ["/contact/", "Contact", "footer-contact"], ["/mentions-legales/", "Mentions légales", "footer-legal"], ["/confidentialite/", "Confidentialité", "footer-privacy"]];

export const Footer = () => (
  <footer className="footer footer-v2" data-testid="site-footer">
    <div className="footer-row">
      <Logo testid="footer-logo" />
      <nav className="footer-links" aria-label="Pied de page">
        {LINKS.map(([to, label, id]) => <Link key={to} to={to} data-testid={id}>{label}</Link>)}
      </nav>
    </div>
    <div className="footer-bottom">
      <small>© 2026 NovaSoft Ltd · Île Maurice · BRN C25226236</small>
      <a href={mailto()} data-testid="footer-email">{CONTACT_MAIL}</a>
    </div>
  </footer>
);
